import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_VEHICLES_DOCUMENTS_TYPES_DATA } from "./actionTypes";
import {
  fetchVehiclesDocumentsTypesSuccess,
  fetchVehiclesDocumentsTypesFailure,
} from "./actions";

function* fetchVehiclesDocumentsTypesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/vehicles-documents-types",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchVehiclesDocumentsTypesSuccess(response.data));
  } catch (error) {
    yield put(fetchVehiclesDocumentsTypesFailure(error.message));
  }
}

export default function* vehiclesDocumentsTypesSaga() {
  yield takeEvery(FETCH_VEHICLES_DOCUMENTS_TYPES_DATA, fetchVehiclesDocumentsTypesDataSaga);
}
